import { render } from "./credit-note-details.vue?vue&type=template&id=675b1c20"
import script from "./credit-note-details.vue?vue&type=script&lang=js"
export * from "./credit-note-details.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__